import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Component } from '@angular/core';
import { GenericListView } from '../../../infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { GenericService } from '../../../infrastructure/infrastructure-services/services/base/generic-service';
import { PageEvent } from '@angular/material/paginator';
import { GenericEntryForm } from '../../../infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { enumErrorMessageText, enumFormModes } from '../../../infrastructure/infrastructure-services/common/common-enums';
import { mapper } from 'src/app/infrastructure/infrastructure-services/common/mapper';
import { TransporterMasterModel, ITransporterMasterModel, EwbTransporter_Lines_List, ITransporterMasterModelSAP, TransporterMasterModelSAP } from 'src/app/core/models/masters/transporter-master.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { DataService } from 'src/app/shared/constants/data.service';
import { GenericAutoCompleteView } from 'src/app/infrastructure/infrastructure-services/generics/generic-autocomplete-view/generic-autocomplete-view';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';
import { TransferState } from '@angular/platform-browser';
import { SecurityService } from 'src/app/login-layout/Service/security.service';

interface TransportMode {
  modeName: string;
  mode: string;
}
interface VehicleType {
  vehicleTypeName: string;
  vehicleType: string;
}

@Component({
  selector: 'app-transporter-master-entryform',
  templateUrl: './transporter-master-entryform.component.html'
})
export class TransporterMasterEntryformComponent extends GenericEntryForm<ITransporterMasterModel, ITransporterMasterModelSAP> {
  auser: any;
  dataSource: any[] = [];
  displayedColumns: any[] = [];
  isLinear: boolean = false
  VehicleType: any;
  TransportMode: any;
  
  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;
  isActiveMenu: boolean = true;

  checkMenuPermissions() {
    let securityService = new SecurityService();
    let permissions = securityService.getMenuPermissions("Transporter Master");
    this.canAdd = permissions.canAdd;
    this.canEdit = permissions.canEdit;
    this.canView = permissions.canView;
    this.isActiveMenu = permissions.isActive;
  }

  genAutoComplete = new GenericAutoCompleteView<ITransporterMasterModel>(this.agenericRepositoryForCfl, this.routerForCfl);

  constructor(agenericRepository: GenericService<ITransporterMasterModel>, private activatedRoute: ActivatedRoute, router: Router,
    public matDialogforCfl: MatDialog, public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<ITransporterMasterModel>>,
    @Inject(MAT_DIALOG_DATA) private data: any, private dbService: NgxIndexedDBService, dialog: MatDialog,
    public agenericRepositoryForCfl: GenericService<ITransporterMasterModel>, public routerForCfl: Router, public dataService: DataService,private http: HttpClient) {
    super(agenericRepository, router, dialog);

    this.setMenuCode = "M311";
    this.setListViewFormRouteTo = "/home/sales/transportermasterlistview/";
    // this.setURLForFormModeNew = "EWBTransporters/NewEWBTransportersService";
    this.setURLForFormModeEdit = "EWBTransporters/GetEWBTransportersService";
    this.setURLForFormModeAddSap = "EWBTransporters";
    this.setURLForFormModeUpdateSap = `EWBTransporters(${this.activatedRoute.snapshot.params['id']})`;
    this.displayedColumns = ["sno", "modeName", "vehicleType", "vehicleNo", "delete"];
    this.dataService.tableName = 'TransporterMaster'
    let transporter = new TransporterMasterModel();
    let transporterSap = new TransporterMasterModelSAP();
    transporter.absEntry = this.activatedRoute.snapshot.params['id'] != 0 ? this.activatedRoute.snapshot.params['id'] : "";
    this.setEntryFormDataSource = transporter;
    this.setEntryFormDataSourceSAP = transporterSap;


    let transporterlist = new EwbTransporter_Lines_List();
    transporter.ewbTransporter_Lines.push(transporterlist);
    if (transporter.absEntry > 0) {
      this.setRequestDataForFormModeEdit = transporter.absEntry;
      this.setFormMode = enumFormModes.ModeEdit;
    }
    else {
      this.setFormMode = enumFormModes.ModeNew;
    }
    this.checkMenuPermissions();
    this.PopulateEntryForm()

  }

  // myControlVehicleType = new FormControl<string | VehicleType>('');
  // myControlTransportMode = new FormControl<string | TransportMode>('');
  // optionsVehicleType: VehicleType[] = []
  // OptionTransportMode: TransportMode[] = []
  // filteredOptionsVehicleType!: Observable<VehicleType[]>;
  // filteredOptionsTransportMode!: Observable<TransportMode[]>;

  // ngOnInit() {
  //   this.getIntialAPIListForTransportMode();
  //   this.getIntialAPIListForVehicleType();
  //   this.filteredOptionsVehicleType = this.myControlVehicleType.valueChanges.pipe(
  //     startWith(''),
  //     map(value => {
  //       const name = typeof value === 'string' ? value : value?.vehicleTypeName;
  //       return name ? this._filterVehicleType(name as string) : this.optionsVehicleType.slice();
  //     }),
  //   );

  //   this.filteredOptionsTransportMode = this.myControlTransportMode.valueChanges.pipe(
  //     startWith(''),
  //     map(value => {
  //       const name = typeof value === 'string' ? value : value?.modeName;
  //       return name ? this._filterTransportMode(name as string) : this.OptionTransportMode.slice();
  //     }),
  //   );
  // }
  
  // async getIntialAPIListForTransportMode() {
  //   this.genAutoComplete.setACDataSourceURL = 'EWBTransportersMode/GetEWBTransportersModeListService';
  //   this.genAutoComplete.setACSortColumn = "sequenceNo";
  //   let result = await this.genAutoComplete.onClickOptionsList();
  //   result.forEach((element: any) => {
  //     this.OptionTransportMode.push({ 'modeName': element.modeName, 'mode': element.mode });
  //   });
  // }

  // async getIntialAPIListForVehicleType() {
  //   this.genAutoComplete.setACDataSourceURL = 'EWBVehicleType/GetEWBVehicleTypeListService';
  //   this.genAutoComplete.setACSortColumn = "sequenceNo";
  //   let result = await this.genAutoComplete.onClickOptionsList();
  //   result.forEach((element: any) => {
  //     this.optionsVehicleType.push({ 'vehicleTypeName': element.vehicleTypeName, 'vehicleType': element.vehicleTypeName });
  //   })
  // }

  // private _filterVehicleType(name: string): VehicleType[] {
  //   const filterValue = name.toLowerCase();
  //   return this.optionsVehicleType.filter(option => option.vehicleTypeName.toLowerCase().includes(filterValue));
  // }

  // private _filterTransportMode(name: string): TransportMode[] {
  //   const filterValue = name.toLowerCase();
  //   return this.OptionTransportMode.filter(option => option.modeName.toLowerCase().includes(filterValue));
  // }

  // OnOptionSelectedVehicleType(option: VehicleType, index: any) {
  //   this.VehicleType = option;
  //   this.VehicleType = option ? option.vehicleType : null;
  //   this.getEntryFormDataSource.ewbTransporter_Lines[index].vehicleType = this.VehicleType;
  // }

  // OnOptionSelectedTransportMode(option: TransportMode, index: any) {
  //   this.TransportMode = option;
  //   this.TransportMode = option ? option.mode : null;
  //   this.getEntryFormDataSource.ewbTransporter_Lines[index].mode = this.TransportMode;
  // }

  onValidate(): boolean {
    let lreturn: boolean = true;
    let value = [];
    let data: any = this.getEntryFormDataSource;

    data.transporterCode == null || data.transporterCode.length == 0 ? value.push(enumErrorMessageText.transporterCodeStatus) : null;
    data.transporterName == null || data.transporterName.length == 0 ? value.push(enumErrorMessageText.transporterNameStatus) : null;
    data.transporterID == null || data.transporterID.length == 0 ? value.push(enumErrorMessageText.transporterIDStatus) : null;

    this.showValidationArr = value;
    this.title = this.getFormSubTitle;
    if (this.showValidationArr.length != 0) {
      lreturn = false
    }
    return lreturn
  }

  onSave(aEvent: any) {
    if (this.btnText == 'Language.OkText') {
      this.routerForCfl.navigate([this.getListViewFormRouteTo]);
    }
    else {
      if (this.onValidate()) {

        let dto = mapper.map(this.getEntryFormDataSource, TransporterMasterModel, TransporterMasterModelSAP);
        this.setEntryFormDataSourceSAP = dto;
        this.SaveEntryForm();
      }
      else {
        this.openDialog();
      }
    }
  }

  selectedData: any;
  onOpenDropDown(value: any, id: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) {
      return;
    }
    let genCFL = new GenericCflViewComponent<ITransporterMasterModel>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);

    if (value == 1) {
      genCFL.setCflTitle = "Trasnporter Mode";
      genCFL.setIsCflSingleSelection = true;
      //genCFL.setIsCflMultipleSelection=true;
      genCFL.setCflViewDataSourceURL = 'EWBTransportersMode/GetEWBTransportersModeListService';
      genCFL.setCflDisplayedColumnsNamesList = ['modeName'];
      genCFL.setCflSelectedData = this.selectedData;
      genCFL.setSortColumn = "sequenceNo";
      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
        if (res != undefined && res.event != undefined) {
          if (this.btnText == 'Language.OkText') {
            this.btnText = 'Language.UpdateText';
          }
          this.selectedData = res.event;
          this.getEntryFormDataSource.ewbTransporter_Lines[id].modeName = res.event.modeName;
          this.getEntryFormDataSource.ewbTransporter_Lines[id].mode = res.event.mode;
        }
      })
    }

    if (value == 2) {
      genCFL.setCflTitle = "Vehicle Type";
      genCFL.setIsCflSingleSelection = true;
      //genCFL.setIsCflMultipleSelection=true;
      genCFL.setCflViewDataSourceURL = 'EWBVehicleType/GetEWBVehicleTypeListService';
      genCFL.setCflDisplayedColumnsNamesList = ['vehicleTypeName'];
      genCFL.setCflSelectedData = this.selectedData;
      genCFL.setSortColumn = "sequenceNo";
      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
        if (res != undefined && res.event != undefined) {
          if (this.btnText == 'Language.OkText') {
            this.btnText = 'Language.UpdateText';
          }
          this.selectedData = res.event;
          this.getEntryFormDataSource.ewbTransporter_Lines[id].vehicleType = res.event.vehicleType;
          this.getEntryFormDataSource.ewbTransporter_Lines[id].vehicleTypeName = res.event.vehicleTypeName
        }
      })
    }
  }

  addRow() {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) {
      return;
    }
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }
    let lineItem = new EwbTransporter_Lines_List();
    lineItem.flag=true;
    this.getEntryFormDataSource.ewbTransporter_Lines.push(lineItem);
    this.getEntryFormDataSource.ewbTransporter_Lines = [...this.getEntryFormDataSource.ewbTransporter_Lines];
  }

  deleteRow(index: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) {
      return;
    }
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }

    if (this.getEntryFormDataSource.ewbTransporter_Lines[index].flag != true) {
      this.getEntryFormDataSource.ewbTransporter_Lines.splice(index, 1);
      this.getEntryFormDataSource.ewbTransporter_Lines = [...this.getEntryFormDataSource.ewbTransporter_Lines];
      this.DeleteDataFromSAP(index);
    }
    else {
      this.getEntryFormDataSource.ewbTransporter_Lines.splice(index, 1);
      this.getEntryFormDataSource.ewbTransporter_Lines = [...this.getEntryFormDataSource.ewbTransporter_Lines];
    }
  }

  DeleteDataFromSAP(index: number) {
    this.getEntryFormDataSource.ewbTransporter_Lines.forEach((e: any, i: number) => {
      if (e.flag == true) {
        this.getEntryFormDataSource.ewbTransporter_Lines.splice(i, 1);
      }
    });
    let dto = mapper.map(this.getEntryFormDataSource, TransporterMasterModel, TransporterMasterModelSAP);
    this.http.put(this.getURLForFormModeUpdateSap, dto, { withCredentials: true }).
      subscribe((res: any) => {
        console.log(res);
      })
  }
}
